import { styled } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';

export const StyledToggleButton = styled(ToggleButton)(() => ({
  '&.Mui-disabled': {
    pointerEvents: 'auto',
  },
  '&:hover': {
    backgroundColor: 'royalblue',
  },
  '&.Mui-selected': {
    backgroundColor: 'royalblue',
    color: 'white',
  },
  backgroundColor: 'white',
  color: 'black',
  flexDirection: 'column',
}));
